export default __webpack_public_path__ + "static/media/showers-day.509a1ba1.svg";